import type { BscProgramme } from 'src/types/BscProgramme'
import type { MscProgramme } from 'src/types/MscProgramme'
import type { ShortTermProgramme } from 'src/types/ShortTermProgramme'
import type { Programme, ProgrammeType } from 'src/types/Programme'

export function isShortTermProgramme(
  p: Programme | BscProgramme | MscProgramme | ShortTermProgramme | null | undefined,
  programme_type: ProgrammeType
): p is ShortTermProgramme {
  return programme_type === 'short'
}

export function isMscProgramme(
  p: Programme | BscProgramme | MscProgramme | ShortTermProgramme | null | undefined,
  programme_type: ProgrammeType
): p is MscProgramme {
  return programme_type === 'msc'
}

export function isBscProgramme(
  p: Programme | BscProgramme | MscProgramme | ShortTermProgramme | null | undefined,
  programme_type: ProgrammeType
): p is BscProgramme {
  return programme_type === 'bsc'
}
